var React = require('react');

function Results (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M30 0c16.6 0 30 13.4 30 30 0 16.6-13.4 30-30 30 -16.6 0-30-13.4-30-30 0-16.6 13.4-30 30-30Zm9 39c0 2.5 2 4.5 4.5 4.5 2.5 0 4.5-2 4.5-4.5l0-6c0-2.5-2-4.5-4.5-4.5 -2.5 0-4.5 2-4.5 4.5l0 6Zm-22.5 4.5c-2.5 0-4.5-2-4.5-4.5l0-12c0-2.5 2-4.5 4.5-4.5 2.5 0 4.5 2 4.5 4.5l0 12c0 2.5-2 4.5-4.5 4.5Zm13.5 0c-2.5 0-4.5-2-4.5-4.5l0-21c0-2.5 2-4.5 4.5-4.5 2.5 0 4.5 2 4.5 4.5l0 21c0 2.5-2 4.5-4.5 4.5Z"}));
}

Results.defaultProps = {"width":"60","height":"60","viewBox":"0 0 60 60","style":{"clipRule":"evenodd","fillRule":"evenodd","strokeLinejoin":"round","strokeMiterlimit":"2","version":"1"}};

module.exports = Results;

Results.default = Results;
